export const stringReplacement = (findString, replaceWith, wholeText = '') =>
  wholeText.replace(findString, replaceWith)

export default {}